import { client } from "./index";

// Image library of one website (/api/admin/sites/:siteId/media)
// Largest file that can be chosen, per kind of image (the server checks the same)
export const MAX_IMAGE_BYTES = 2 * 1024 * 1024;
export const IMAGE_LIMITS = { banner: 5 * 1024 * 1024, product: 2 * 1024 * 1024, logo: 2 * 1024 * 1024 };

export const uploadMedia = (siteId, file, kind = "product") => {
  const formData = new FormData();
  formData.append("file", file);
  return client.post(`/admin/sites/${siteId}/media/upload`, formData, { params: { kind } });
};

export const getMedia = (siteId) => client.get(`/admin/sites/${siteId}/media`);
